const state = {
  pending_transaction : false,
  user_has_bonus: false,
  pending_ticket: 0,
}
const getters = {
  getTicketCount(state) {
    return state.pending_ticket
  },
  getPendingTransaction(state){
    return state.pending_transaction
  },
  getUserHasBonus(state){
    return state.user_has_bonus
  }
}
const mutations = {
  setTicketCount(state, val) {
    state.pending_ticket = val
  },
  setPendingTransaction(state, val){
    state.pending_transaction = val
  },
  setUserHasBonus(state, val){
    state.user_has_bonus = val
  }
}
const actions = {
  ticketCount({ commit}){
    axios.get('user/tickets/count')
    .then((response) => {
      commit('setTicketCount', response.data.count)
    })
  },
  initPendingTransaction({ commit }){
    return axios.get('user/wallet/count')
      .then((response) => {
          if(response.data.status){
            commit('setPendingTransaction', response.data.count > 0);
            let user = this.getters['auth/user'];
            commit('setUserHasBonus', ((!_.isUndefined(user.bonus_type) && user.bonus_type == 'freebet') ? true : false));
          }
      })
  },
  setToPending({commit}, payload){
    commit('setPendingTransaction', payload);
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}